import * as types from '@/store/mutation-types'
export default {
    namespaced: true,
    state: {
        messages: []
    },

    actions: {
        fetchAll ({ commit }, { centerId, userName }) {
            return window.axios.get(`/center/${centerId}/user/${userName}/quick-messages`).then(({ data }) => {
                commit(types.STORE_MESSAGES, data)
                return data
            })
        },

        sendMessage ({ commit }, { centerId, userName, AccountIds, QuickMessageId }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/send-quick-message`, { AccountIds, QuickMessageId }).then((data) => {
                return data
            })
        }
    },

    mutations: {
        [types.STORE_MESSAGES] (state, messages) {
            state.messages = messages
        }
    },

    getters: {}
}
